<template>
  <div id="preview" class="sms-preview">
    <div class="sms-preview__image">
      <img class="sms-preview__image-logo"
          v-if="logo"
          width="34"
          height="34"
          :src="logo"
        />
      <div class="sms-preview__name">{{ company }}</div>
      <div class="sms-preview__text" v-html="fixedTemplate"></div>
    </div>
  </div>
</template>

<script>
import methods from "@/components/nodes/previewMethods.js";
import { scaleHeight } from "@/utils/general";

export default {
  name: "SmsPreview",
  mixins: [methods],
  mounted() {
    scaleHeight(".template--sms", ".sms-preview", 255, 477);
  }
}
</script>

<style lang="scss">
.sms-preview {
  width: 375px;
  transform-origin: 50% 0%;
  &__image {
    position: relative;
    width: 375px;
    height: 477px;
    background: url("#{$image-path}template-sms.png") no-repeat center center #fff;
    &-logo {
      border-radius: 50%;
      position: absolute;
      left: 10px;
      top: 76px;
      width: 50px;
      height: 50px;
      object-fit: cover;
    }
  }

  &__name {
    position: absolute;
    left: 72px;
    top: 80px;
    font-size: 15px;
    line-height: 17px;
    font-weight: bold;
    color: $color_black;
  }

  &__text {
    position: absolute;
    width: 277px;
    left: 72px;
    top: 100px;
    font-size: 13px;
    line-height: 14px;
    color: #8c8c8c;
    max-height: 30px;
    overflow: hidden;
    // @include overflow-ellipsis();
    // @extend %very-long-letters-protection;
  }
}
</style>